import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import About from "../components/About";
import Services from "../components/Services";
import Films from "../components/Films";
import Venues from "../components/Venues";
import Packages from "../components/Packages";
import Testimonials from "../components/Testimonials";
import BehindTheScenes from "../components/BehindTheScenes";
import FAQ from "../components/FAQ";
import ContactCTA from "../components/ContactCTA";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Services />
        <Films />
        <Venues />
        <Packages />
        <Testimonials />
        <BehindTheScenes />
        <FAQ />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
};

export default Home;
